import { forwardRef, ReactNode } from 'react';
import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
} from '@mui/material';

export interface TypographyProps extends MuiTypographyProps {
  children?: ReactNode;
}

export const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ children, ...props }, ref) => {
    return (
      <MuiTypography ref={ref} {...props}>
        {children}
      </MuiTypography>
    );
  },
);

Typography.displayName = 'Typography';
